import { Panel, Tab, Tabs } from "react-bootstrap";

import BiPolarBarChart from "../../elements/Charts/BiPolarBarChart";
import Card from "../Card/Card";
import ChartBudgetCategoryProjectTab from "./ChartBudgetCategoryProjectTab";
import ChartBudgetCategoryTab from "./ChartBudgetCategoryTab";
import ChartBudgetCategoryTiersTab from "./ChartBudgetCategoryTiersTab";
import ChartBudgetClientClientTabPure from "./ChartBudgetClientClientTab";
import ChartBudgetProjectTab from "./ChartBudgetProjectTab";
import ChartCategoryTab from "./ChartCategoryTab";
import ChartClientPerformanceTabPure from "./ChartClientPerf";
import ChartClientTab from "./ChartClientTab";
import ChartCompanyTab from "./ChartCompanyTab";
import ChartProductTab from "./ChartProductTab";
import ChartProjectTab from "./ChartProjectTab";
import ChartQuantityTab from "./ChartQuantityTab";
import ChartSellerTab from "./ChartSellerTab";
import ChartTaxTab from "./ChartTaxTab";
import ChartTiersTab from "./ChartTiersTab";
import ChartTreasuryTab from "./ChartTreasuryTab";
import ChartChargesIncomesTab from "./ChartChargesIncomesTab";
import ChartsBudgetsDataCompute from "../Reporting/ChartsBudgetsDataCompute";
import ChartsDataCompute from "../Reporting/ChartsDataCompute";
import ChartsPerformanceDataCompute from "./ChartPerformanceDataCompute";
import ChartsTaxesDataCompute from "./ChartsTaxesDataCompute";
import Queries from "../../queries/queries2";
import React from "react";
import _ from "lodash-es";
import { compose } from "recompose";
import { graphql } from "react-apollo";
import { injectIntl } from "react-intl";
import Spinner from "../../elements/Spinner/Spinner";

class ReportingChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.buildState(props); // compute initial state - no setState in constructor !

    const tabFromSession = sessionStorage.getItem(
      `reportingContainer_${this.props.name}_currentTab`
    );

    this.state.key = tabFromSession ? tabFromSession : props.tabs[0];
    // console.log("42 - ReportingChart state", props, this.state);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.currentYear !== prevProps.currentYear ||
      this.props.currentPeriod !== prevProps.currentPeriod ||
      this.props.selectedPeriod !== prevProps.selectedPeriod ||
      (this.props.edges && prevProps.edges && this.props.edges.length !== prevProps.edges.length) ||
      (this.props.edgesAlternate && prevProps.edgesAlternate && this.props.edgesAlternate.length !== prevProps.edgesAlternate.length)
    ) {
      this.setState(this.buildState(this.props));
    }
  }

  buildState = props => {
    // console.log("48 - P=",props);

    let state = {};

    switch (props.type) {
      case "taxes":
        state = ChartsTaxesDataCompute(
          props,
          props.edges,
          props.negateValues,
          props.splitAmountsByCategory,
          props.type,
          props.intl
        );
        break;

      case "budgets":
        state = ChartsBudgetsDataCompute(
          props,
          props.edges,
          props.negateValues,
          props.splitAmountsByCategory,
          props.type,
          props.intl
        );
        break;

      case "performance":
        const tabFromSession = sessionStorage.getItem(
          `reportingContainer_${props.name}_currentTab`
        );
        const keyTab = tabFromSession ? tabFromSession : "clientPerf";

        state = ChartsPerformanceDataCompute(props, props.edges, keyTab);
        break;

      default:
        state = ChartsDataCompute(
          props,
          props.edges,
          props.negateValues,
          props.splitAmountsByCategory,
          props.type,
          props.intl
        );

        // console.log("104 - state=", state);
        break;
    }
    return state ? state : { tabData: [], tabDataAlternate: [] };
  };

  onExpandedChange = value => {
    console.log("onExpandedChange", value);
    this.setState({ expanded: value });
  };

  resetExpanded = () => {
    this.setState({ expanded: false });
  };

  onTabSelected = key => {

    console.log("113 - (onTabSelected) this.props.name=", this.props.name, key);
    this.resetExpanded();
    this.setState({ key });
    sessionStorage.setItem(
      `reportingContainer_${this.props.name}_currentTab`,
      key
    );
  };
  render() {
    console.log("ReportingChart render", this.props);

    const { intl } = this.props;
    const onRowClick = this.props.onRowClick
      ? this.props.onRowClick
      : alert("missing onRowClik");

    let stringBudgets = this.props.intl.formatMessage({ id: "ids_budgets" });
    stringBudgets =
      stringBudgets.charAt(0).toUpperCase() + stringBudgets.slice(1);

    let stringRealValues = this.props.intl.formatMessage({
      id: "ids_realValues"
    });
    stringRealValues =
      stringRealValues.charAt(0).toUpperCase() + stringRealValues.slice(1);

    const previousYear = {
      title:
        this.props.type === "budgets" ? stringBudgets : this.props.previousYear,
      data: this.state.previousYearData,
      color: "#188ec9",
      year: this.props.currentYear - 1
    };

    const currentYear = {
      title:
        this.props.type === "budgets"
          ? stringRealValues
          : this.props.currentYear,
      data: this.state.currentYearData,
      color: "#a8213e",
      year: this.props.currentYear
    };

    const previousYearNegative = {
      title:
        this.props.type === "budgets" ? stringBudgets : this.props.previousYear,
      data: this.state.previousYearDataNegative,
      color: "#188ec9",
      year: this.props.currentYear - 1
    };

    const currentYearNegative = {
      title:
        this.props.type === "budgets"
          ? stringRealValues
          : this.props.currentYear,
      data: this.state.currentYearDataNegative,
      color: "#a8213e",
      year: this.props.currentYear
    };

    const showData = this.props.showData === undefined || this.props.showData;
    const showChart =
      this.props.showChart === undefined || this.props.showChart;

    return (
      <React.Fragment>
        {showChart && (
          <Panel>
            {currentYear.data && previousYear.data && (
              <BiPolarBarChart
                previousYear={previousYear}
                previousYearNegative={previousYearNegative}
                currentYear={currentYear}
                currentYearNegative={currentYearNegative}
                // withDifference
                // differenceTitle="Résultat"
                onSelectedPeriod={this.props.onSelectedPeriod}
                displayLines={this.props.displayLines}
                displayBars={this.props.displayBars}
                intl={intl}
                companyDefaultInfos={this.props.companyDefaultInfos}
              />
            )}
          </Panel>
        )}
        {showData && (
          <Tabs
            id="report-charts-tabs"
            activeKey={this.state.key}
            onSelect={this.onTabSelected}
          >
            {_.map(this.props.tabs, tab => {
              // console.log("171 - tab=", tab);
              switch (tab) {
                case "taxes":
                  // console.log("220 - case.taxes", this);
                  return (
                    <Card key="taxes">
                      {this.props.loadingMore ? <Spinner /> : <div></div>}
                      <ChartTaxTab
                        {...this.state}
                        {...this.props}
                        data={this.state.tabData}
                        onExpandedChange={this.onExpandedChange}
                        onRowClick={onRowClick}
                      />
                    </Card>
                  );
                case "company":
                  return (
                    <Tab
                      key="company"
                      eventKey={"company"}
                      title={intl.formatMessage({ id: "ids_company" })}
                    >
                      {this.state.key === tab && (
                        <ChartCompanyTab
                          {...this.state}
                          {...this.props}
                          data={this.state.tabData}
                          currentYear={currentYear}
                          previousYear={previousYear}
                          onExpandedChange={this.onExpandedChange}
                          onRowClick={onRowClick}
                        />
                      )}
                    </Tab>
                  );
                case "categories":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="categories"
                      eventKey={"categories"}
                      title={intl.formatMessage({ id: "ids_categories" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartCategoryTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "tiersAsClient":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="tiersAsClient"
                      eventKey={"tiersAsClient"}
                      title={intl.formatMessage({ id: "ids_client" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartTiersTab
                            {...this.state}
                            {...this.props}
                            customColumnName={"tiersAsClient"}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "tiersAsSupplier":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="tiersAsSupplier"
                      eventKey={"tiersAsSupplier"}
                      title={intl.formatMessage({ id: "ids_supplier" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartTiersTab
                            {...this.state}
                            {...this.props}
                            customColumnName={"tiersAsSupplier"}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "budgetCategoryTiers":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="budgetCategoryTiers"
                      eventKey={"budgetCategoryTiers"}
                      title={intl.formatMessage({ id: "ids_tiers" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartBudgetCategoryTiersTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "tiers":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="tiers"
                      eventKey={"tiers"}
                      title={intl.formatMessage({ id: "ids_tiers" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartTiersTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                            showProductColumn={
                              this.props.showProductColumn !== undefined
                                ? this.props.showProductColumn
                                : undefined
                            }
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "project":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="project"
                      eventKey={"project"}
                      title={intl.formatMessage({ id: "ids_project" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartProjectTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                            showProductColumn={
                              this.props.showProductColumn !== undefined
                                ? this.props.showProductColumn
                                : undefined
                            }
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "budgetCategoryProject":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="budgetCategoryProject"
                      eventKey={"budgetCategoryProject"}
                      title={intl.formatMessage({ id: "ids_project" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartBudgetCategoryProjectTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "budgetProject":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="budgetProject"
                      eventKey={"budgetProject"}
                      title={intl.formatMessage({ id: "ids_project" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartBudgetProjectTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "budgetClientClient":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="budgetClientClient"
                      eventKey={"budgetClientClient"}
                      title={intl.formatMessage({ id: "ids_client" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartBudgetClientClientTabPure
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "budgetCategory":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="budgetCategory"
                      eventKey={"budgetCategory"}
                      title={intl.formatMessage({ id: "ids_category" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartBudgetCategoryTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "client":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="client"
                      eventKey={"client"}
                      title={intl.formatMessage({ id: "ids_client" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartClientTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "clientPerf":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="clientPerf"
                      eventKey={"clientPerf"}
                      title={intl.formatMessage({ id: "ids_client" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartClientPerformanceTabPure
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "product":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="product"
                      eventKey={"product"}
                      title={intl.formatMessage({ id: "ids_product" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartProductTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );
                case "seller":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="seller"
                      eventKey={"seller"}
                      title={intl.formatMessage({ id: "ids_seller" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartSellerTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "treasury":
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="treasury"
                      eventKey={"treasury"}
                      title={intl.formatMessage({ id: "ids_treasury" })}
                    >
                      {this.state.key === tab && (
                        <Card>
                          {this.props.loadingMore ? <Spinner /> : <div></div>}
                          <ChartTreasuryTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "charges_incomes":
                  console.log("617 - this.props.loadingMore=", this.props.loadingMore);
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="charges_incomes"
                      eventKey={"charges_incomes"}
                      title={
                        intl.formatMessage({ id: "ids_charges_incomes" })
                      }
                    >
                      {this.state.key === tab && (
                        <Card>
                          {this.props.loadingMore ? <Spinner /> : <div></div>}
                          <ChartChargesIncomesTab
                            {...this.state}
                            {...this.props}
                            data={this.state.tabDataAlternate}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                case "quantity":
                  console.log("617 - this.props.loadingMore=", this.props.loadingMore);
                  return (
                    <Tab
                      style={{ padding: "0" }}
                      key="quantity"
                      eventKey={"quantity"}
                      title={
                        intl.formatMessage({ id: "ids_quantity" })
                      }
                    >
                      {this.state.key === tab && (
                        <Card>
                          <ChartQuantityTab
                            {...this.state}
                            {...this.props}
                            customColumnName={"tiersAsClient"}
                            data={this.state.tabData}
                            currentYear={currentYear}
                            previousYear={previousYear}
                            onExpandedChange={this.onExpandedChange}
                            onRowClick={onRowClick}
                          />
                        </Card>
                      )}
                    </Tab>
                  );

                default:
                  return <div />;
              }
            })}
          </Tabs>
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  graphql(Queries.getCompanyInfoForContainer, { name: "companyDefaultInfos" })
)(injectIntl(ReportingChart));
